import { render, staticRenderFns } from "./aliyunCaptcha.vue?vue&type=template&id=e0c40f26&"
import script from "./aliyunCaptcha.vue?vue&type=script&lang=js&"
export * from "./aliyunCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./aliyunCaptcha.vue?vue&type=style&index=0&id=e0c40f26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports